import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class AdministrationService {
  constructor(private http: HttpClient) { }
  GetRCAData(type: any) {
    return this.http.get(AUTH_API + `/settings/GetRCAData?PatientType=${type}`)
  }

  AddRCATree(node:any,formtype:any,level:any,nodeAvailable:any,PatientDiagramOption:any) {
    return this.http.post(AUTH_API + `/settings/EditRCARecord?FormType=save&ParentId=${node.parent}&Id=${node.id}&Title=${node.text}&PatientType=${formtype}&Root_Level=${level}&PatientNodeAvilable=${nodeAvailable}&PatientDiagramOption=${PatientDiagramOption}`, '')
  }
  EditRCATree(DataTreeNodeInfo:any,title:any,FormType: any,level:any,nodeAvailable:any,PatientDiagramOption:any) { 

  return this.http.post(AUTH_API + `/settings/EditRCARecord?FormType=edit&ParentId=${DataTreeNodeInfo.parent}&Id=${DataTreeNodeInfo.id}&Title=${title}&PatientType=${FormType}&Root_Level=${level}&PatientNodeAvilable=${nodeAvailable}&PatientDiagramOption=${PatientDiagramOption}`, '')
  }

  DeleteRCATree(node: any, PatientType: any) { 
    return this.http.post(AUTH_API + `/settings/DeleteRCA?id=${node.id}&PatientType=${PatientType}`,'')
  }
 
}
